import { render, staticRenderFns } from "./EditCategoryNew.vue?vue&type=template&id=5d4d0e18&scoped=true&"
import script from "./EditCategoryNew.vue?vue&type=script&lang=js&"
export * from "./EditCategoryNew.vue?vue&type=script&lang=js&"
import style0 from "./EditCategoryNew.vue?vue&type=style&index=0&id=5d4d0e18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d0e18",
  null
  
)

export default component.exports